import { render, staticRenderFns } from "./InterviewQuestion.vue?vue&type=template&id=7021dc48&scoped=true&"
import script from "./InterviewQuestion.vue?vue&type=script&lang=js&"
export * from "./InterviewQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021dc48",
  null
  
)

export default component.exports